module.exports = __webpack_public_path__ + "img/live-music.73ef8fde.png";